import { render } from "./NbaScores.vue?vue&type=template&id=0280622f&scoped=true"
import script from "./NbaScores.vue?vue&type=script&lang=js"
export * from "./NbaScores.vue?vue&type=script&lang=js"

import "./NbaScores.vue?vue&type=style&index=0&id=0280622f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0280622f"]])

export default __exports__